import transformRequest from './helpers/transform';

/**
 * This transform Layer is used by component like
 * Histogram, Calendar and Hero
 */

/**
 * This method return a Request object after delete unnecesary paramter
 * @param {*} request Request Object pass to client request API axios at this moment
 */
const transformRequestSubscription = (request) => {
  // params to delete don't matter the value store
  const paramsDelete = [
    'airlineCode',
    'airport',
    'airlineIataCode',
    'languageCode',
    'origin',
    'name',
    'email',
    'listID'
  ];

  // params to delete when has empty value
  const paramsEmpty = ['Origin', 'origin', 'PhoneNumber', 'phoneNumber', 'MobileNumber'];

  const cleanRequest = transformRequest(request, paramsDelete, paramsEmpty);

  return cleanRequest;
};

export default transformRequestSubscription;
